const CN_DOMAIN = 'https://www.xchr-group.com'

const legacyToInternalMap = {
  '/index.html': '/',
  '/about_gyxc.html': '/home/about-xc',
  '/joinus.html': '/home/jobs',
  '/contact.html': '/home/contact-us',
  '/service.html': '/home/labor-relations',
  '/private.html': '/home/contact-us',
  '/news.html': '/home/menu',
  '/productService/lab.html': '/home/labor-relations',
  '/productService/talent.html': '/home/labor-relations',
  '/productService/manage.html': '/home/labor-relations',
  '/productService/internet.html': '/home/labor-relations'
}

function normalizeLegacyLink(link) {
  if (!link) return '/'

  if (link.startsWith('http://') || link.startsWith('https://')) {
    try {
      const url = new URL(link)
      return `${url.pathname}${url.hash || ''}` || '/'
    } catch (_e) {
      return link
    }
  }

  return link.startsWith('/') ? link : `/${link}`
}

function splitPathAndHash(pathWithHash) {
  const hashIndex = pathWithHash.indexOf('#')
  if (hashIndex === -1) {
    return { pathname: pathWithHash, hash: '' }
  }
  return {
    pathname: pathWithHash.slice(0, hashIndex),
    hash: pathWithHash.slice(hashIndex)
  }
}

export function isChineseLocale(locale) {
  return (locale || 'zh-CN') === 'zh-CN'
}

export function toChineseDomainLink(link) {
  const normalized = normalizeLegacyLink(link)
  if (normalized.startsWith('http://') || normalized.startsWith('https://')) {
    return normalized
  }
  return `${CN_DOMAIN}${normalized}`
}

export function toInternalLink(link, locale) {
  const normalized = normalizeLegacyLink(link)
  const { pathname, hash } = splitPathAndHash(normalized)
  const mappedPath = legacyToInternalMap[pathname] || pathname
  const query = isChineseLocale(locale) ? '' : '?lang=en'
  return `${mappedPath}${query}${hash}`
}

export function resolveLocaleLink(locale, link) {
  if (isChineseLocale(locale)) {
    return toChineseDomainLink(link)
  }
  return toInternalLink(link, locale)
}

